module.exports = __webpack_public_path__ + "static/media/secCount.f68653d4.png";